const common = {
  Loading: "Loading",
  signUp: "Sign Up",
  login: "Login",
  logout: "Logout",
  email: "E-mail",
  emailFormatErrorTips: "The E-mail format is incorrect",
  emailDifferentTips: "Please enter the same email in both fields.",
  emailRegisteredTips: "This E-mail has been registered, please choose another.",
  password: "Password",
  passwordFormatErrorTips:
    "The password must be 8-50 characters and contain at least two categories among the following: number, letter or special character.",
  passwordDifferentTips: "Please enter the same password in both fields.",
  verificationCode: "Verification code",
  verificationCodeErrorTips: "Incorrect verification code",
  confirm: "Confirm",
  cancel: "Cancel",
  submit: "Submit",
  confirmEmail: "Confirm E-mail",
  formEmptyErrorTips: "Cannot be empty here.",
  country: "Country / Region",
  birthday: "Birthday",
  anonymous: "Anonymous",
  name: "Name",
  nameFormatErrorTips: "Username should be within 50 characters and does not contain special characters.",
  okBtn: "OK",
  serverErrorTips: "Sorry, something went wrong, please try again later.",
  updateSuccessTips: "Modified successfully",
  authorizationExpiredErrorTips: "Authorization has expired, please log in again.",
  requestFrequentlyErrorTips: "Too many same requests were made in a short period of time, please try again later.",
};

export default common;
